export default __webpack_public_path__ + "static/media/rocket_anim_155.bbfb1de0.png";